import React, { useState } from "react";

import * as api from "./api";
import Button from "./components/Button";

export default function SignIn({
  signedIn,
  onSignedIn,
  onSignOut,
}: {
  signedIn: boolean;
  onSignedIn: () => void;
  onSignOut: () => void;
}) {
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const envLabel = api.getEnvLabel();

  const handle = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.signInWithGoogle();
      onSignedIn();
    } catch (e: any) {
      setError(e?.message || "Sign-in failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
        background: "radial-gradient(120% 120% at 85% -10%, #F0E7FE 0%, var(--paper) 46%)",
      }}
    >
      <div
        style={{
          width: 400,
          maxWidth: "100%",
          background: "#fff",
          border: "1px solid var(--border-hairline)",
          borderRadius: 20,
          padding: "40px 38px",
          boxShadow: "var(--elevation-lift)",
          textAlign: "center",
        }}
      >
        <img src="/lockup-color.png" alt="Wingscript" style={{ height: 40, width: "auto", margin: "0 auto 4px", display: "block" }} />
        <div style={{ fontFamily: "var(--font-mono)", fontSize: 11, letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--violet-500)", marginBottom: 22 }}>ops console</div>
        <h1 style={{ margin: "0 0 8px", fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 22, letterSpacing: "-0.02em", color: "var(--ink-900)" }}>Internal staff console</h1>
        <p style={{ margin: "0 0 26px", fontSize: 13.5, color: "var(--text-muted)", lineHeight: 1.55 }}>
          Cross-tenant support &amp; containment. Access is staff-only and every action is audited.
        </p>
        <Button variant="primary" size="lg" onClick={handle} disabled={busy} style={{ width: "100%" }}>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="m16 17 5-5-5-5" /><path d="M21 12H9" /></svg>
            {busy ? "Signing in…" : "Sign in with Google"}
          </span>
        </Button>
        {signedIn && (
          <p style={{ margin: "16px 0 0", fontSize: 13, color: "var(--danger-500)" }}>
            Signed in, but this account has no ops access. Ask a superadmin to grant it.{" "}
            <button onClick={onSignOut} style={{ background: "none", border: "none", color: "var(--violet-500)", cursor: "pointer", padding: 0, font: "inherit" }}>Sign out</button>
          </p>
        )}
        {error && <p style={{ margin: "16px 0 0", fontSize: 13, color: "var(--danger-500)" }}>{error}</p>}
        <p style={{ margin: "22px 0 0", fontFamily: "var(--font-mono)", fontSize: 10.5, letterSpacing: "0.06em", color: "var(--text-faint)" }}>ops.wingscript.com · {envLabel}</p>
      </div>
    </div>
  );
}
